import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Input,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardSubtitle,
  CardText,
  Button,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobLists } from "@workspace/job/src/store/actions";

function ClientDashboard() {
  document.title = "Client Dashboard | Pulse";
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const jobsData = useSelector((state) => state?.JobListReducer?.jobs);
  const [jobs, setJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const request = {
      page: 0,
      pageSize: 50,
      sortDirection: "asc",
      // filters: [
      //   {
      //     condition: "Equal",
      //     dbDataType: "jsonb",
      //     field: "job_submission_data.accountName",
      //     label: "Account Name",
      //     value: "Deloitte",
      //     jobType: "all_jobs",
      //   },
      // ],
    };

    dispatch(fetchJobLists(request));
  }, []);

  useEffect(() => {
    if (jobsData) {
      setJobs(jobsData?.jobs);
    }
  }, [jobsData]);

  const filterJobs = () => {
    const filtered = jobsData?.jobs?.filter((job) => {
      const jobTitle = job?.jobSubmissionData?.jobTitle?.toLowerCase() || "";
      const country = job?.jobSubmissionData?.country?.toLowerCase() || "";
      const jobId = job?.jobSubmissionData?.jobId?.toLowerCase() || "";
      const accountContact =
        job?.jobSubmissionData?.accountContact?.toLowerCase() || "";

      return (
        jobTitle.includes(searchTerm.toLowerCase()) ||
        country.includes(searchTerm.toLowerCase()) ||
        jobId.includes(searchTerm.toLowerCase()) ||
        accountContact.includes(searchTerm.toLowerCase())
      );
    });
    setFilteredJobs(filtered);
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row className="mb-3">
          <Col lg={6}>
            <div className="fw-light h4">Jobs ({jobs?.length || 0})</div>
          </Col>
          <Col lg={6}>
            <div className="d-flex flex-row gap-2 justify-content-end align-items-center">
              <div className="search-box" style={{ width: "300px" }}>
                <Input
                  type="text"
                  placeholder="Search.."
                  className="form-control"
                  style={{ border: "1px solid #E7E9EB" }}
                  // value={searchQuery}
                  // onChange={(e) => handleSearch(e.target.value)}
                />
                <i className="ri-search-line search-icon"></i>
              </div>

              <span className="mdi mdi-filter cursor-pointer fs-4"></span>
            </div>
          </Col>
        </Row>
        <Row>
          {jobs && jobs.length > 0 ? (
            jobs?.map((job, index) => {
              const jobDetail = job?.jobSubmissionData;
              return (
                <Col key={index} lg={4} className="h-100">
                  <Card
                    onClick={() => navigate(`/client/job/${job?.id}`)}
                    className="cursor-pointer"
                  >
                    <CardBody className="p-3">
                      <div
                        style={{ backgroundColor: "transparent" }}
                        className="d-flex flex-row align-items-center justify-content-between"
                      >
                        <div
                          style={{
                            fontSize: "16px",
                            color: "#0A65CC",
                          }}
                        >
                          #{jobDetail?.jobId}
                        </div>
                        <div className="d-flex flex-row gap-2 align-items-center">
                          <Button
                            className="d-flex flex-row align-items-center justify-content-center gap-1"
                            style={{ padding: "2px 4px" }}
                          >
                            <i
                              className="mdi mdi-briefcase-variant-outline"
                              style={{ fontSize: "18px" }}
                            />
                            24
                          </Button>
                          <span
                            className="mdi mdi-dots-horizontal cursor-pointer"
                            style={{ color: "#0A56AE" }}
                          ></span>
                        </div>
                      </div>
                      <CardTitle
                        style={{
                          fontWeight: "500",
                          color: "black",
                          fontSize: "17px",
                        }}
                      >
                        <div>{jobDetail?.jobTitle}</div>
                      </CardTitle>
                      <CardSubtitle
                        style={{
                          display: "flex",
                          gap: "4px",
                          marginTop: "7px",
                          marginBottom: "8px",
                        }}
                      >
                        <Button
                          size="sm"
                          style={{ backgroundColor: "#EDEEEE" }}
                        >
                          {jobDetail?.workType}
                        </Button>
                        <Button
                          size="sm"
                          style={{
                            backgroundColor: "#E9F3F9",
                            color: "#429BCC",
                          }}
                        >
                          Level
                        </Button>
                      </CardSubtitle>
                      <CardText
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          borderTop: "1px solid",
                          borderColor: "#8F8F8F",
                          marginTop: "5px",
                          paddingTop: "6px",
                        }}
                      >
                        <div style={{ color: "#8F8F8F" }}>
                          <i
                            className="mdi mdi-map-marker-outline"
                            style={{ color: "#0A65CC", marginRight: "3px" }}
                          />
                          {jobDetail?.country}
                        </div>
                        <div style={{ color: "#8F8F8F" }}>
                          <i
                            className="mdi mdi-calendar-blank-outline"
                            style={{ color: "#0A65CC", marginRight: "3px" }}
                          />
                          {jobDetail?.dateOpen}
                        </div>
                        <div style={{ color: "#8F8F8F" }}>
                          <i
                            className="mdi mdi-account"
                            style={{ color: "#0A65CC", marginRight: "3px" }}
                          />
                          {jobDetail?.accountContact}
                        </div>
                      </CardText>
                    </CardBody>
                  </Card>
                </Col>
              );
            })
          ) : (
            <span className="text-muted">No jobs listed.</span>
          )}
        </Row>
      </div>
    </div>
  );
}

export default ClientDashboard;
